import { Link } from "react-router-dom";

export const AuthorLink = ({ song, className = "", testId }) => (song.owner_id
  ? <Link to={`/autorius/${song.owner_id}`} data-testid={testId || `author-link-${song.id}`}
    className={`hover:text-[var(--c-orange)] transition-colors ${className}`}>{song.author_name}</Link>
  : <span className={className}>{song.author_name}</span>);
